export const ROUTES = {
  SIGN_IN: "/auth/sign-in",
  SIGN_UP: "/auth/sign-up",
  HOME: "/",
  TASK: "/task",
  TEMPLATES: "/templates",
  PROJECTS: "/projects",
  TRIGGERS: "/triggers",
  RELICS: "/relics",
  MEMORY: "/memory",
  KNOWLEDGE_CONFIG: "/knowledge-config",
  SETTINGS: "/settings",
  NOTIFICATIONS: "/settings/notifications",
  VERIFY_EMAIL: "/auth/verify-email",
  SET_PASSWORD: "/auth/set-password/:token",
}

// Keep nested template tab paths relative (no leading slash).
export const TEMPLATE_TAB_PATHS = {
  MY_TEMPLATES: "my-templates",
  TEAM_TEMPLATES: "team-templates",
  EXPLORE: "explore",
  USER_TEMPLATES: "user-templates",
  COMPANY_LIBRARY: "company-library",
  MDO: "mdo",
}

// The MDO template builder. Nested under /templates but deliberately
// NOT a tab: it carries its own breadcrumb + step bar, so it must fall
// through to the detail-page branch in Templates.jsx rather than render
// inside the tab chrome.
export const MDO_SETUP_PATH = `${TEMPLATE_TAB_PATHS.MDO}/setup`
export const MDO_SETUP_ROUTE = `${ROUTES.TEMPLATES}/${MDO_SETUP_PATH}`

// A saved plan's own page — what a card on the MDO tab opens. Also a
// detail page, for the same reason as the builder above.
export const MDO_PLAN_PATH = `${TEMPLATE_TAB_PATHS.MDO}/plan`
export const MDO_PLAN_ROUTE = `${ROUTES.TEMPLATES}/${MDO_PLAN_PATH}`

export const PROJECT_TAB_PATHS = {
  ACTIVE:    'active',
  COMPLETED: 'completed',
}

export const TRIGGER_TAB_PATHS = {
  ALL: "all",
  ACTIVE: "active",
  PAUSED: "paused",
  ENDED: "ended",
  SCHEDULED: "scheduled",
  CONFLICTS: "conflicts",
  AUDIT_LOG: "audit-log",
}

